/** biome-ignore-all lint/a11y/useSemanticElements: legacy */

import type { Locale } from '@core/Entities/Locale/Locale.entity';
import type { FilterKey } from '@core/Entities/Search/QueryParams.entity';
import type { FilterValueDisplayObj } from '@core/Entities/Search/SearchFilters/FilterValueDisplayObj.entity';
import { VEHICLE_STATUS_VALUES } from '@core/Services/Search/Search.constants';

import { useUpdateFilters } from 'Hooks/SearchFilters/UseUpdateFilters';

import { CANT_DELETE } from './ActiveFiltersOverview.constants';

export const useGetDeleteFn = (locale?: Locale) => {
  const { updateFilters } = useUpdateFilters();

  const handleRemoveFilter = (filter: FilterValueDisplayObj) => {
    const filterChanges = filter.originalFilters.map(filterToRemove => {
      if (Array.isArray(filter.originalFilters[0].value)) {
        return {
          id: filterToRemove.id,
          value: filter.originalFilters[0].value.filter(value => value !== filter.value),
        };
      }

      return { id: filterToRemove.id, value: undefined };
    });

    updateFilters(filterChanges);
  };

  const handleRemoveLocationFilters = () => {
    updateFilters([
      { id: 'region', value: undefined },
      { id: 'area', value: undefined },
      { id: 'postcode', value: undefined },
      { id: 'lat', value: undefined },
      { id: 'lon', value: undefined },
      { id: 'max-distance', value: undefined },
    ]);
  };

  const handleRemoveDealershipFilters = () => {
    updateFilters([
      { id: 'region', value: undefined },
      { id: 'area', value: undefined },
      { id: 'postcode', value: undefined },
      { id: 'lat', value: undefined },
      { id: 'lon', value: undefined },
      { id: 'max-distance', value: undefined },
      { id: 'dealer-id', value: undefined },
      { id: 'dealership-id', value: undefined },
    ]);
  };

  const handleRemoveVehicleStatus = () => {
    updateFilters([{ id: 'vehicle-status', value: VEHICLE_STATUS_VALUES.includeSold }]);
  };

  const getDeleteFn = (filter: FilterValueDisplayObj) => {
    if (CANT_DELETE[locale || 'uk']?.includes(filter.id as FilterKey)) return undefined;

    if (filter.id === 'area' || filter.id === 'region') return () => handleRemoveLocationFilters();

    if (filter.id === 'dealership-id') return () => handleRemoveDealershipFilters();

    if (filter.id === 'vehicle-status') return () => handleRemoveVehicleStatus();

    return () => handleRemoveFilter(filter);
  };

  return { getDeleteFn };
};
